<template lang="pug">
.popover-container(:class="popoverContainerClasses")
  span(
    v-if="lazy"
    ref="VuePopperReference"
    :class="`d-flex ${spanClass}`"
    v-on="triggerEvent"
  )
    slot(name="trigger")
  VuePopper(
    v-if="loadPopover"
    v-show="!lazy"
    ref="AppPopover"
    :trigger="trigger"
    append-to-body
    :options="options"
    :disabled="disabled"
    :delay-on-mouse-over="delay"
    :delay-on-mouse-out="delay"
    :reference="reference || $refs.VuePopperReference"
    :root-class="rootClass"
    @created="onCreated"
    @hide="onHide"
    @show="onShow"
  )
    .popover.vue-popover.fade.in(
      :id="id"
      :class="classes"
    )
      h3.popover-title.ellipsis.d-flex.align-items-center.justify-content-between(v-if="showHeader")
        slot(name="header")
        button.close.header-close(
          v-if="showCloseButton"
          type="button"
          aria-hidden="true"
          @click="close"
        )
          i.hi.hi-close.hi-9
      .popover-content
        button.close(
          v-if="showCloseButton && !showHeader"
          type="button"
          aria-hidden="true"
          @click="close"
        )
          i.hi.hi-close.hi-9
        // TODO: Refactor this to use the default slot
        slot(name="body")
        slot
    template(
      v-if="!lazy"
      slot="reference"
    )
      slot(name="trigger")
</template>

<script>
import VuePopper from 'vue-popperjs';

export default {
  name: 'AppPopover',
  components: { VuePopper },
  props: {
    popoverContainerClasses: {
      type: String,
      default: 'is-block',
    },
    placement: {
      type: String,
      default: 'top-start',
    },
    extraPopoverClasses: {
      type: String,
      default: '',
    },
    rootClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
    boundariesElement: {
      type: String,
      default: 'viewport',
    },
    id: {
      type: String,
      default: '',
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    trigger: {
      type: String,
      default: 'click',
    },
    delay: {
      type: Number,
      default: 400,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    reference: {
      type: Element,
    },
    hideFromAction: {
      type: Boolean,
      default: false,
    },
    spanClass: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loadPopover: !this.lazy,
    };
  },
  computed: {
    options() {
      return {
        placement: this.placement,
        modifiers: {
          hide: {
            enabled: true,
          },
          preventOverflow: {
            boundariesElement: this.boundariesElement,
          },
        },
      };
    },
    classes() {
      let classes = this.extraPopoverClasses;

      if (this.dropdown) {
        classes += ' popover-dropdown';
      }

      return classes;
    },
    showCloseButton() {
      return !(this.isHover || this.dropdown || this.hideClose);
    },
    showPopper() {
      return !!this.$refs.AppPopover?.showPopper;
    },
    isHover() {
      return this.trigger === 'hover';
    },
    triggerEvent() {
      if (!this.lazy) {
        return {};
      }
      switch (this.trigger) {
        case 'hover':
          return { mouseover: this.openPopover, focus: this.openPopover };
        default:
          // Click event
          return { click: this.openPopover };
      }
    },
  },
  watch: {
    hideFromAction(newVal) {
      if (newVal && this.$refs.AppPopover) {
        this.close();
      }
    },
  },
  methods: {
    open() {
      if (this.loadPopover) {
        this.$refs.AppPopover.showPopper = true;
      } else {
        this.openPopover();
      }
    },
    close() {
      this.$refs.AppPopover.showPopper = false;
    },
    onCreated() {
      this.$emit('created', true);
    },
    onHide() {
      this.$emit('hide', true);
    },
    onShow() {
      this.$emit('show');
    },
    openPopover() {
      if (!this.loadPopover) {
        this.loadPopover = true;
        this.$nextTick(() => {
          this.open();
        });
      }
    },
  },
};
</script>
